<crypto-transaction-agreements (submit)="onAgreements()">
    <loading *ngIf="loading" class="full">
        <ng-container i18n="@@cryptoAddress.loading">Loading your digital asset address</ng-container>
    </loading>

    <error *ngIf="error">
        {{error}}
    </error>

    <div *ngIf="data && !error">
        <div *ngIf="showTitle" class="d-flex align-items-center page-title">
            <currency [currency]="currency?.code" class="lg"></currency>
            <div class="p-1"></div>
            <div i18n="@@cryptoAddress.title">Your {{currency?.name}} ({{currency?.code}}) receiving address</div>
        </div>

        <p i18n="@@cryptoAddress.description">Please scan this QR to copy the address</p>
        <qrcode [qrdata]="data?.address?.address" [size]="150" class="qr mb-4" colordark="#557671"></qrcode>

        <p i18n="@@cryptoAddress.copyText">Or copy the address below:</p>
        <text-copy [value]="data?.address?.newFormatAddress || data?.address?.address" class="mb-3"></text-copy>

        <ng-container [ngSwitch]="data?.address?.currency">
            <ng-container *ngSwitchCase="'XRP'">
                <p i18n="@@cryptoAddress.tag">Tag:</p>
                <text-copy [value]="data?.address?.additionalId"></text-copy>
            </ng-container>
            <ng-container *ngSwitchCase="'XLM'">
                <p i18n="@@cryptoAddress.memo">Memo:</p>
                <text-copy [value]="data?.address?.additionalId"></text-copy>
            </ng-container>
            <ng-container *ngSwitchCase="'EOS'">
                <p i18n="@@cryptoAddress.memo">Memo:</p>
                <text-copy [value]="data?.address?.additionalId"></text-copy>
            </ng-container>
        </ng-container>

        <div *ngIf="data?.address?.legacyAddress" class="shower pt-3">
            <a href="javascript:void(0);" class="header" [class.active]="showLegacyAddress" (click)="toggleLegacyAddress()">
                <ng-container i18n="@@cryptoAddress.legacyAddress">Legacy Address</ng-container>
            </a>
            <div *ngIf="showLegacyAddress">
                <text-copy [value]="data?.address?.legacyAddress"></text-copy>
            </div>
        </div>

        <div class="p-2"></div>

        <p>
            <span class="text-bold" i18n="@@crypto.network">Network:</span>
            &nbsp;
            <span *ngFor="let network of data?.network">
                {{network?.name}} <ng-container *ngIf="network?.code">({{network?.code}})</ng-container>
            </span>
        </p>
        <div class="p-2"></div>
        
        <div *ngIf="data?.info" class="notes">
            <div class="title">
                <img src="assets/images/icons/warning.svg" alt="" class="icon-lg">
                <div class="p-1"></div>
                <div i18n="@@cryptoAddress.pleaseNote">Please note the following:</div>
            </div>   
            <ul>
                <li *ngFor="let info of data?.info" [class]="info.severity" innerHTML="{{info.text}}">{{info.text}}</li>
            </ul>
        </div>
    </div>
</crypto-transaction-agreements>